import Icon from "../Icon/Icon";
import styles from "./iconButton.css";

/**
 * The IconButton is an element, which only displays a clickable icon. It
 * includes an alternative text for screen readers and any of the Design System
 * icons can be selected by name.
 *
 * @param {Object} props - The props object.
 * @param {string} props.name - The name of the icon to be displayed.
 * @param {string} [props.size="24px"] - The size of the icon.
 * @param {function} props.onClick - The click event handler for the button.
 * @param {string} [props.value] - The value of the button.
 * @param {string} [props.title] - The title attribute for the button, providing additional information on hover.
 * @param {string} [props.theme="light"] - The theme of the button, can be 'light' or 'purple'.
 *
 * @return {JSX.Element} The rendered IconButton component.
 */
function IconButton({
  name,
  size = "24px",
  onClick,
  value,
  title,
  theme = "light",
}) {
  return (
    <button
      type="button"
      className={styles.button({ theme })}
      onClick={onClick}
      value={value}
      title={title}
    >
      <Icon name={name} size={size} aria-labelledby={`${name}-title-id`} />
    </button>
  );
}

export default IconButton;
